// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Maa-z","fadeIn":"Naa-z","delay":"Oaa-z","recommendedSizeTooltip":"Paa-z"};